<template>
  <div id="app">
    <!-- <header id="site-header">
      <div class="header-wrapper">
        <div class="logo-wrapper">
          <img class="logo" alt="Giraff logo" src="@/assets/giraff-logo.png"><span class="project-name">{{projectName}}</span>
        </div>
        <div id="nav">
          <router-link to="/">Home</router-link>
          <router-link to="/report">Report</router-link>
          <router-link to="/about">About</router-link>
          <router-link class="login-link" v-if="!isLoggedIn" to="/login">Login</router-link>
          <span class="logout-link" v-if="isLoggedIn"><a @click="logout">Logout</a></span>
        </div>

      </div>
    </header> -->
    <template>
      <div class="hidden">
        <vs-navbar shadow square center-collapsed v-model="active" fixed>
          <template #left>
            <img class="site-logo" alt="Giraff logo" src="@/assets/giraff-logo.png">
          </template>
          <template #right>
            <vs-button @click="activeSidebar = !activeSidebar" icon size="large">
              <font-awesome-icon icon="bars" class="menu-toggle-icon" v-if="!activeSidebar"/>
              <font-awesome-icon icon="times" class="menu-toggle-icon" v-else/>
            </vs-button>
          </template>
        </vs-navbar>
        <vs-sidebar
            v-model="active"
            :open.sync="activeSidebar"
            background="#2B3B4E"
            textWhite
        >
          <template #logo>
            <img class="logo" alt="Giraff logo" src="@/assets/giraff-logo.png">
          </template>

          <router-link to="/">
          <vs-sidebar-item id="home" >
            <template #icon>
              <font-awesome-icon icon="clipboard-list"/>
            </template>
            Home
          </vs-sidebar-item>
          </router-link>

          <router-link to="/report">
            <vs-sidebar-item id="report">
              <template #icon>
                <font-awesome-icon icon="calendar-alt"/>
              </template>
              Report
            </vs-sidebar-item>
          </router-link>


          <vs-sidebar-item id="about" to="/about">
            <template #icon>
              <i class='bx bxs-music'></i>
            </template>
            About
          </vs-sidebar-item>
          <!-- <vs-sidebar-item id="login" to="/login">
            <template #icon>
              <font-awesome-icon icon="calendar-alt" />
            </template>
            Login
          </vs-sidebar-item> -->

          <template #footer>
            <vs-row justify="space-between" align="center">
              <!-- <router-link class="login-link" v-if="!isLoggedIn" to="/login">Login</router-link> -->
              <div class="project">
                <span class="project-name">{{ projectName }}</span>
              </div>
              <vs-button
                  v-if="isLoggedIn"
                  style="min-width: 60px"
                  danger
                  @click="logout"
                  animation-type="vertical"
              >
                <font-awesome-icon icon="sign-out-alt"/>
                <template #animate>
                  Logout
                </template>
              </vs-button>

            </vs-row>
          </template>
        </vs-sidebar>
      </div>
    </template>
    <v-app>
      <keep-alive>
        <router-view/>
      </keep-alive>
    </v-app>
  </div>
</template>
<script>
export default {
  mounted: function () {
    console.log(this.$route)
    if (this.$route.name.toLowerCase() == 'login') {
      this.active = 'Home'
    } else {
      this.active = this.$route.name.toLowerCase()
    }
  },
  data: () => ({
    active: 'Home',
    activeSidebar: false
  }),
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn
    },
    projectName: function () {
      return this.$store.getters.projectName
    }
  },
  methods: {
    logout: function () {
      this.$store.dispatch('logout')
          .then(() => {
            this.$router.push('/login')
          })
    }
  }
}
</script>
<style lang="sass">
body
  .v-application--wrap
    height: 100%
    min-height: 100%

#app
  font-family: Avenir, Helvetica, Arial, sans-serif
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  text-align: center
  height: 100%

.vs-navbar
  .vs-navbar__left
    padding: 1em 1em
    +mobile
      padding: 1em 0

  .vs-navbar__right
    .vs-button
      background-color: $Main

      .menu-toggle-icon
        width: 1em

  .site-logo
    height: 2em
    width: auto
    display: inline-block

.vs-sidebar-content
  height: 100% !important

.vs-sidebar-content
  .project
    font-size: 12px
// header#site-header
//   position: sticky
//   background-color: white
//   z-index: 1000
//   top: 0
//   .header-wrapper
//     display: flex
//     padding: 1em 2em
//     flex-direction: row
//     align-items: center
//     justify-content: space-between
//     .logo-wrapper
//       display: flex
//       flex-direction: row
//       align-items: center
//       .logo
//         height: 3em
//         width: auto
//         display: inline-block
//       .project-name
//         display: inline-block
//         margin-left: 1em
//         font-size: 1.2em
//         font-weight: bold
//     #nav
//       padding: 1em 0


//       a
//         font-weight: bold
//         color: #2c3e50
//         margin: 0 0.5em
//         text-decoration: none


//         &.router-link-exact-active
//           color: $Safe

//       .login-link,.logout-link
//         margin-left: 1em
//         border-radius: 5px
//         text-decoration: none
//         text-transform: uppercase
//         line-height: 1
//         font-size: 0.8em
//         border: 2px solid transparent
//         cursor: pointer
//         display: inline-block
//         &.login-link
//           border-color: $Safe
//           color: black
//           padding: 0.5em 0.75em 0.4em
//           font-size: 0.8em
//         &.logout-link
//           border-color: $Warning
//           a
//             color: black
//         a
//           font-size: 1em
//           padding: 0.5em 0.75em 0.4em
//           display: inline-block

</style>
